import { App } from "./App";
import { ContactPage } from "./components/ContactPage";
import { EventRegisterPage } from "./events/EventRegisterPage";
import { EventsIndex } from "./events/EventsIndex";

/**
 * Tiny path router for the NZ site: the home page, the events index
 * at /events, and per-event registration pages at /events/<slug>
 * (flyer QR deep-links). No library — a switch on pathname is enough
 * for three surfaces, and it keeps the bundle lean.
 */
function normalizePath(pathname: string): string {
  return pathname.length > 1 && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;
}

export function Router() {
  const pathname = normalizePath(window.location.pathname);

  if (pathname === "/events" || pathname.startsWith("/events/")) {
    const slug = pathname.slice("/events/".length).split("/")[0] ?? "";
    if (slug) {
      return <EventRegisterPage slug={slug} />;
    }
    return <EventsIndex />;
  }

  if (pathname === "/contact") {
    return <ContactPage />;
  }

  return <App />;
}
